import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { departmentsActions } from '../actions/departments.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class DepartmentsEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getDepartments$ = createEffect(() => {
        return this.actions.pipe(
            ofType(departmentsActions.getDepartments),
            switchMap(({ value }) => {
                return this.httpService.getDepartments(value).pipe(
                    map((payload) => departmentsActions.getDepartmentsSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(departmentsActions.getDepartmentsError({ code: error.status }))),
                );
            }),
        );
    });

    getDepartmentsLookup$ = createEffect(() => {
        return this.actions.pipe(
            ofType(departmentsActions.getDepartmentsLookup),
            switchMap(({ value }) => {
                return this.httpService.getDepartmentsLookup(value).pipe(
                    map((payload) => departmentsActions.getDepartmentsLookupSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(departmentsActions.getDepartmentsLookupError({ code: error.status }))),
                );
            }),
        );
    });
}
